import { useState } from 'react';

export function EmailModal({ isOpen, onClose, title, description, email, subjectHint }) {
  const [copied, setCopied] = useState(false);

  const handleCopy = () => {
    navigator.clipboard.writeText(email);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  if (!isOpen) return null;

  return (
    <>
      <div 
        className="fixed inset-0 bg-black/30 dark:bg-black/50 z-40 flex items-center justify-center"
        onClick={onClose}
      >
        <div 
          className="bg-white dark:bg-[#161B22] p-6 md:p-8 rounded-xl shadow-xl border border-gray-200 dark:border-[#30363D] w-[90%] max-w-md m-4 relative z-50"
          onClick={(e) => e.stopPropagation()}
        >
          <button 
            className="absolute top-3 right-3 text-gray-400 hover:text-gray-600 dark:hover:text-gray-200"
            onClick={onClose}
          >
            <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
          <h3 className="text-xl font-bold text-gray-900 dark:text-white mb-3">
            {title}
          </h3>
          <p className="text-gray-700 dark:text-[#C9D1D9] mb-4">
            {description}
          </p>
          <div className="bg-gray-100 dark:bg-gray-800 p-3 rounded-lg mb-4 flex items-center justify-between">
            <span className="font-mono text-blue-600 dark:text-blue-400">{email}</span>
            <button 
              onClick={handleCopy}
              className="text-gray-500 hover:text-gray-700 dark:hover:text-gray-300"
              title="Copy to clipboard"
            >
              {copied ? (
                <svg className="w-5 h-5 text-green-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                </svg>
              ) : (
                <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 5H6a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2v-1M8 5a2 2 0 002 2h2a2 2 0 002-2M8 5a2 2 0 012-2h2a2 2 0 012 2m0 0h2a2 2 0 012 2v3m2 4H10m0 0l3-3m-3 3l3 3" />
                </svg>
              )}
            </button>
          </div>
          {subjectHint && (
            <p className="text-sm text-gray-500 dark:text-gray-400">
              Include &quot;{subjectHint}&quot; in the subject line of your email.
            </p>
          )}
        </div>
      </div>
    </>
  );
} 